<main class="ib-layout">
    <div class="container">
        <div class="row">
            <div class="col-xs-12">
                <div class="ib-layout__header ib-layout__header--pre-title-large u-text-right">
                    <a class="ib-link ib-link--icon hidden-md hidden-sm hidden-xs" ng-click="confirmationCtrl.printSummary()" title="{{'CONFIRM_PRINT_PAYMENT'|translate}}">
                        <span class="ib-link__icon icon-imprimir"></span>
                        <span class="ib-link__text">{{'CONFIRM_PRINT_CONFIRM'|translate}}</span>
                    </a>
                    <h1 class="ib-heading ib-heading--type-18 ib-heading--block ib-heading--to-center">
                        <span class="ib-heading__icon ib-heading__icon--default ib-heading__icon--mobile-block icon-confirmacion hidden-xs hidden-sm"></span>
                        <span class="ib-heading__text">{{'CONFIRM_BUY_OK_TXT'|translate}}</span>
                    </h1>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-8 col-xs-12">
                <div class="ib-layout__section ib-layout__section--large-responsive">
                    <div class="ib-box ib-box--empty ib-box--bordered ib-box--gift-card">
                        <div class="ib-box__wrapper">
                            <div class="ib-layout__line-spacing">
                                <div class="ib-gift-card ib-gift-card--small">
                                    <figure class="ib-gift-card__figure ib-gift-card__figure-resized">
                                        <img src="../iberia-web-content\imagenes\subscription-models\plane-confirm.svg" alt="Imagen Avión Iberia" />
                                    </figure>
                                </div>
                            </div>
                        </div>
                        <div class="ib-box__wrapper ib-box__wrapper--medium">
                            <div class="ib-layout__line-spacing ib-layout__line-spacing--text-center ib-layout__line-spacing--xmedium-responsive ">
                                <p class="ib-text ib-text--to-center ib-text--color-unfocused ib-text--lh-normal-responsive ib-text--italic">
                                    {{'SUBSCRIPTION_MODELS_CONFIRMATION_CONFIRMATION_SENT_NEW_PAYMENTS'|translate : {passenger_email: passengerEmail} }}
                                </p>
                            </div>
                            <div class="ib-layout__line-spacing ib-layout__line-spacing--text-center">
                                <div class="ib-box ib-box--small">
                                    <p class="ib-text ib-text--block ib-text--especial ib-text--to-center ib-text--color-unfocused ib-text--lh-normal">
                                        {{'SUBSCRIPTION_MODELS_CONFIRMATION_REMEMBER_NEW_PAYMENTS'|translate}}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-xs-12">
                <div class="ib-layout__section ib-layout__section--medium">
                    <ng-react [component]="summaryComponent.component" [props]="summaryComponent.props"></ng-react>
                </div>
            </div>
        </div>
        <equal-height  class="ib-box-confirmation-info">
            <div class="row ib-layout__section">
                <div class="col-sm-12 col-md-4">
                        <div class="ib-box ib-box--small ib-box--empty ib-box--bordered u-height-auto-sm" data-equal="box-info">
                            <div class="ib-info-icon ib-info-icon--small">
                                <div class="ib-info-icon__wrapper">
                                    <span class="ib-info-icon__icon icon-logo_aplic_peque"></span>
                                    <div class="ib-info-icon__info">
                                        <div class="ib-layout__line-spacing ib-layout__line-spacing--xsmall">
                                            <span class="ib-heading ib-heading--type-5">{{'SUBSCRIPTION_MODELS_CONFIRM_IBERIA_PLUS'|translate}}</span>
                                        </div>
                                        <span class="ib-text ib-text--lh-medium">{{'SUBSCRIPTION_MODELS_CONFIRM_IBERIA_PLUS_EXPERIENCE'|translate}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                </div>
                <div class="col-sm-12 col-md-4">
                        <div class="ib-box ib-box--small ib-box--empty ib-box--bordered u-height-auto-sm" data-equal="box-info">
                            <div class="ib-info-icon ib-info-icon--small">
                                <div class="ib-info-icon__wrapper">
                                    <span class="ib-info-icon__icon icon-editar_perfil"></span>
                                    <div class="ib-info-icon__info">
                                        <div class="ib-layout__line-spacing ib-layout__line-spacing--xsmall">
                                            <span class="ib-heading ib-heading--type-5">
                                                {{'SUBSCRIPTION_MODELS_CONFIRM_HELP_CENTER'|translate}}
                                            </span>
                                        </div>
                                        <span class="ib-text ib-text--lh-medium">
                                            {{'SUBSCRIPTION_MODELS_CONFIRM_HELP_INFO'|translate}}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                </div>
                <div class="col-sm-12 col-md-4">
                        <div class="ib-box ib-box--small ib-box--empty ib-box--bordered u-height-auto-sm" data-equal="box-info">
                            <div class="ib-info-icon ib-info-icon--small">
                                <div class="ib-info-icon__wrapper">
                                    <span class="ib-info-icon__icon icon-mensajes"></span>
                                    <div class="ib-info-icon__info">
                                        <div class="ib-layout__line-spacing ib-layout__line-spacing--xsmall">
                                            <span class="ib-heading ib-heading--type-5">
                                                {{'CONFIRM_CUSTOMER_SUPPORT'|translate}}
                                            </span>
                                        </div>
                                        <span class="ib-heading" *ngIf="rootScope.phonesList['RESERVAS']"
                                        [class]="{'ib-heading--type-2': (rootScope.phonesList['RESERVAS']?.prefixAlt + ' ' + rootScope.phonesList['RESERVAS']?.telephoneAlt).length < 10,'ib-heading--type-5':(rootScope.phonesList['RESERVAS']?.prefixAlt + ' ' + rootScope.phonesList['RESERVAS']?.telephoneAlt).length >= 10}">{{rootScope.phonesList['RESERVAS']?.prefixAlt
                                        + ' ' + rootScope?.phonesList['RESERVAS']?.telephoneAlt}}</span>
                                    <span class="ib-text">{{'CONFIRM_CONSULT'|translate}}
                                        <a id="pmt-confirmation-twitter-link" class="ib-link" [href]="twitterLink" target="_blank"
                                            rel="noopener noreferrer"
                                            title="{{'CONFIRM_TWITTER_TITLE'|translate}}">{{'CONFIRM_TWITTER_TITLE'|translate}}</a>
                                    </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                </div>
            </div>
        </equal-height>
    </div>
</main>
